@if (!isLoading) {
<div class="carousel-container">
    <div class="carousel-items">
        @for (tie of ties; let i = $index; track i;) {
        <div class="carousel-item">
            <app-match-card [tie]="tie" />
        </div>
        }
    </div>
</div>

@for (tie of ties; let i = $index; track i;) {
<app-tie-scorecard isListView="true" type="team-match" [isLeagueOwner]="isLeagueOwner" [league]="league"
    [style.cursor]="tie?._id ? 'pointer' : 'default'" [tie]="tie" [isOwner]="isOwner" [isOfficial]="isOfficial"
    (click)="openTieDetails(i)"></app-tie-scorecard>
}

@if (!ties?.length) {
<app-empty-page text="{{'You don't have any team matches' | translate}}" iconName="people"></app-empty-page>
}
}